import React from "react";
import Aux from "../utils/AuxFunctions";
// import "./Register.css"
import Fire from "../config/Fire";
import InstagramIcon from "mdi-react/InstagramIcon"
import TwitterIcon from "mdi-react/TwitterIcon"
import SnapchatIcon from "mdi-react/SnapchatIcon"
import { withMyDataContext } from "../context/DataProvider";
import ButtonLoader from "../utils/Utilities/ButtonLoader";
import Colors from "../utils/Colors";
import ErrorMessage from "../utils/ErrorPages/ErrorMessage";
import SucessMessage from "../utils/ErrorPages/SucessMessage";
import ChevronLeftIcon from "mdi-react/ChevronLeftIcon";
class AdminCreateDummy extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {},
            //avatar: "../../assets/tempAvatar.jpg",
            username: "",
            avatar: "",

            deleteAvatar: false,
            name: "",
            bio: "",
            website: "",
            source: "",
            //facebook: "",
            instagram: "",
            twitter: "",
            snapchat: "",
            isLoading: false,
            skipText: true,
            usernameError: "",
            selectedPhoto: null,
            uploadedPhoto: null,
            sucess: false,
            addInfo: false,
        }
    }

    componentDidMount() {
        try {

        } catch (error) {
            Aux.handleError(error);
        }
    }

    photoSelectedHandler = (event) => {
        let photo = URL.createObjectURL(event.target.files[0])
        this.setState({selectedPhoto: photo, avatar: event.target.files[0]})
    }

    deleteAvatar = () => {
        this.setState({ deleteAvatar: true, avatar: "", selectedPhoto: "" });
    }
    
    handleUpdate = async () => {
        if (this.state.isLoading) {
            return;
        }

        const { username, avatar, name, bio, website, source, instagram, twitter, snapchat} = this.state
        this.setState({ isLoading: true });

        try {
            if (username) {
                if (username !== this.props.myDataProvider.user.username) {
                    if (username.length < 5) {
                        this.setState({ isLoading: false, usernameError: "username is too short" });
                        return;
                    } else if (/[^A-Z0-9._-]/gi.test(username)) {
                        this.setState({ isLoading: false, usernameError: 'username can only have ".", "-" and "_"' });
                        return;
                    }

                    let userAvailable = await Fire.shared.CheckIfUsernameExists(username.toLowerCase())
                    if (!userAvailable) {
                        this.setState({ isLoading: false, usernameError: "username already exists" });
                        return;
                    } 
                }
            }
            await Fire.shared.createDummyUser({
                username: username.toLowerCase(),
                avatar: avatar,
                name: name,
                bio: bio,
                website: website,
                source: source,
                twitter: twitter,
                instagram: instagram,
                snapchat: snapchat,
            })
            this.setState({ isLoading: false });
        } catch (error) {
            this.setState({ isLoading: false, usernameError:"An unexpected error has occurred" });
            Aux.handleError(error)
        }
    }

    deleteAvatar = () => {
        this.setState({ deleteAvatar: true, avatar: "", selectedPhoto: "" });
    }

    photoSelectedHandler = (event) => {
        let photo = URL.createObjectURL(event.target.files[0])
        this.setState({selectedPhoto: photo, avatar: event.target.files[0]})
    }

    goBack = () => {
        try {
            this.props.history.goBack();
        } catch (error) {
            Aux.handleError(error)
        }
    }

    goToMyPage = () => {
        try {
            this.props.history.push("/account/profile")
        } catch (error) {
            Aux.handleError(error)
        }
    }

    goToMainPage = () => {
        try {
            this.props.history.push("/")
        } catch (error) {
            Aux.handleError(error)
        }
    }

    onChangedUsername(text) {
        //let num = text.replace(/[^0-9]/g, '')
        let username = text.replace(/[^a-zA-Z0-9-_.]/g, '')
        this.setState({
            username: username,  userNameUpdated:true
        });
    }

    render() {
        return (
            <div style={{width:"100%"}}>
                <section className="container">

                    <div className="reversed-button-hover" style={{display:"flex", alignItems:"center"}} onClick={this.goBack}>
                        <ChevronLeftIcon style={{marginRight:5}}></ChevronLeftIcon>
                        <h2>Add Dummy User</h2>
                    </div>
                    
                    {this.props.myDataProvider.user?.role === "admin" ? 
                    <div style={{display:"flex", flexDirection:"column"}}>

                    

                    <label htmlFor="file" className="custom-file-upload" >
                        <img style={{ height: 60, width: 60, borderRadius: 50, objectFit:"cover", marginTop:20, marginBottom:5 }}
                            src={this.state.selectedPhoto ? this.state.selectedPhoto : ( this.state.avatar ? this.state.avatar : Aux.TemporaryImage)} alt="avatar">
                        </img>
                        <span className="text-hover">Upload photo</span>
                        
                    </label>
                    <input id="file" type="file" className="file-upload" onChange={this.photoSelectedHandler}/>
                    {this.state.selectedPhoto || this.state.avatar ?
                    <div style={{display:"flex", justifyContent:"center", marginTop:5}}>
                    <span className="text-hover" style={{color:Colors.red,}} onClick={this.deleteAvatar}>Remove photo</span>
                    </div> : null}
                    <div style={{marginTop:20}}>
                        <ErrorMessage text={this.state.usernameError}></ErrorMessage>
                        {/* {this.state.usernameError ? <span className="login-error">{this.state.usernameError}</span> : null} */}
  
                        <div>
                            <span style={{marginBottom:3}}>Username</span>
                            <input maxLength={30} className="login-input" type="text" name="username" placeholder="Username" value={this.state.username || ""}
                                onChange={(e) => {
                                    this.onChangedUsername(e.target.value)
                                }}></input>
                        </div>
                        <span style={{marginBottom:3}}>Name</span>
                        <input maxLength={60} className="login-input" type="text" name="name" placeholder="Name" value={this.state.name || ""}
                            onChange={(e) => {
                                this.setState({ name: e.target.value });
                            }}></input>
                        <span style={{marginBottom:3}}>Bio</span>
                        <input maxLength={200} className="login-input" type="text" name="bio" placeholder="Bio" value={this.state.bio || ""}
                            onChange={(e) => {
                                this.setState({ bio: e.target.value });
                            }}></input>
                        <span style={{marginBottom:3}}>Website</span>    
                        <input maxLength={100} className="login-input" type="text" name="website" placeholder="Website" value={this.state.website || ""}
                            onChange={(e) => {
                                this.setState({ website: e.target.value });
                            }}></input>
                        <span style={{marginBottom:3}}>Source</span>    
                        <input maxLength={100} className="login-input" type="text" name="source" placeholder="Source" value={this.state.source || ""}
                            onChange={(e) => {
                                this.setState({ source: e.target.value });
                            }}></input>
                        <span style={{marginBottom:10}}>Social Media</span>

                        <div className="social-profile-container">
                            <InstagramIcon size={30} style={{marginRight:10}}></InstagramIcon>
                            <span>instagram.com/</span>
                            <input maxLength={50} className="login-input social-input" type="text" name="instagram" placeholder="Add your username" value={this.state.instagram || ""}
                                onChange={(e) => {
                                    this.setState({ instagram: e.target.value });
                                }}></input>
                        </div>

                        <div className="social-profile-container">
                            <TwitterIcon size={30} style={{marginRight:10}}></TwitterIcon>
                            <span>twitter.com/</span>
                            <input maxLength={50} className="login-input social-input" type="text" name="twitter" placeholder="Add your username" value={this.state.twitter || ""}
                                onChange={(e) => {
                                    this.setState({ twitter: e.target.value });
                                }}></input>
                        </div>

                        <div className="social-profile-container">
                            <SnapchatIcon  size={30} style={{marginRight:10}}></SnapchatIcon>
                            <span>snapchat.com/</span>
                            <input maxLength={50} className="login-input social-input" type="text" name="snapchat" placeholder="Add your username" value={this.state.snapchat || ""}
                                onChange={(e) => {
                                    this.setState({ snapchat: e.target.value });
                                }}></input>
                        </div>
                        <SucessMessage isSucess={this.state.sucess} text="Your user was updated sucessfully"></SucessMessage>
                        <ButtonLoader
                            text={"Create User"}
                            loading={this.state.isLoading}
                            onClick={this.handleUpdate}
                            style={{ backgroundColor:Colors.mainColor, width:"70%", margin:"20px auto"}}
                        ></ButtonLoader>
                    </div>
                    </div> : 
                    <div style={{display:"flex", justifyContent:"center", alignItems:"center", margin: "20px 0"}}>
                        <span>You're not an admin</span>
                    </div> }
                </section>
            </div>
        );
    }
}

export default withMyDataContext(AdminCreateDummy);